import { RestfulApiService } from './restful-api.service';
import { Store } from '../model/cris/store';

class StoreService extends RestfulApiService<Store> {
    public loadPossibleAttributes() {
        return this.http.get<string[]>(`${this.getUrl()}/attrs`);
    }

    public deploy(entity: Store, withKeywords: boolean) {
        return this.http.post<string[]>(`${this.getAlterUrl(entity)}/deploy?keywords=${withKeywords ? 1 : 0}`);
    }

    protected getFormName(): string {
        return 'store';
    }

    protected getPath(): string {
        return 'stores';
    }
}

export const storeService = new StoreService();
